import { useNavigate, useSearch } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { BeheerderShell } from "@/components/BeheerderShell";
import { Handleiding } from "@/features/handleiding/Handleiding";
import { keepScrollPosition } from "@jbnl/shared-ui";

export function HandleidingPage() {
  const { t } = useTranslation(["paginas", "navigatie"]);
  const { pagina } = useSearch({ from: "/handleiding" });
  const navigate = useNavigate({ from: "/handleiding" });

  return (
    <BeheerderShell
      titel={t("navigatie:paginas.handleiding.label")}
      uitleg={t("handleiding.uitleg")}
    >
      <Handleiding
        slug={pagina}
        onKies={(slug) =>
          void navigate({ ...keepScrollPosition, search: { pagina: slug } })
        }
      />
    </BeheerderShell>
  );
}
